import CityPageTemplate from "../city-template/CityPageTemplate";
import { coloradoSpringsConfig } from "./data";

export default function ColoradoSpringsPage() {
  return <CityPageTemplate config={coloradoSpringsConfig} />;
}